import store from "@/store/store.js";
import DEBUG from "@/store/debug.js";

export default async ({ commit }, investor) => {
    DEBUG("SEND_INVITATION_INVESTOR_START");
    try {
        commit("SET_INVESTORS_LOADING", true);
        const investorRes = await window.app.$api.invite(investor.id);
        DEBUG("SEND_INVITATION_INVESTOR_SUCCESS");
        commit("UPDATE_INVESTOR", investorRes.data);
    } catch (e) {
        DEBUG("SEND_INVITATION_INVESTOR_ERROR");
        window.app.$ui.error(e, "shareledger_invite_investor");
        throw e;
    } finally {
        commit("SET_INVESTORS_LOADING", false);
    }
};
